module.exports = __webpack_public_path__ + "images/default-article.11cabc8563bf04badd74b922a80403ec.png";